import './accordion.scss';

document.addEventListener("DOMContentLoaded", function() {
  if (document.getElementById('accordionSearch')) {
    // Build an array containing all accordeon text value with their index and parent's index
    const contentMapping = [];
    const mainAccordions = document.querySelectorAll('.accordion-fournisseur-section > .pa__item');

    mainAccordions.forEach((mainAccordion, index) => {
      const subAccordions = mainAccordion.querySelectorAll('.pa__item');

      subAccordions.forEach((subAccordion, subIndex) => {
        const elemTitle = subAccordion.querySelector('.accordion-title').textContent;
        contentMapping.push({id: subIndex + 1, parent: index + 1, text: elemTitle});
      });
    });

    const clearSearchBtn = document.querySelector('.search-close-icon');
    
    // Filter content on search change
    document.getElementById('accordionSearch').addEventListener('change', (e)=> {
      showContentPerSearch(e.target.value, contentMapping);
    })

    document.getElementById('accordionSearch').addEventListener('keyup', (e)=> {
      if (clearSearchBtn) {
        if (e.target.value !== "") {
          clearSearchBtn.classList.add('d-block');
        } else {
          clearSearchBtn.classList.remove('d-block');
        }
      }
    })

    if (clearSearchBtn) {
      clearSearchBtn.addEventListener('click', ()=> {
        document.getElementById('accordionSearch').value = "";
        clearSearchBtn.classList.remove('d-block');
        const event = new Event('change');
        document.getElementById('accordionSearch').dispatchEvent(event);
        document.getElementById('accordionSearch').focus();
      })
    }
  }

  if (document.getElementById('condition_accepted')) {
    const checkbox = document.getElementById('condition_accepted');
    const links = document.querySelectorAll('.fournisseur-logo-accordion .logo .download-media');

    links.forEach(link => {
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && link.classList.contains('is-disabled')) {
          e.preventDefault();
        }
      });
    });

    checkbox.addEventListener('change', (e)=> {
      if (e.target.checked) {
        // reactivate buttons
        links.forEach((link) => {
          link.classList.remove('is-disabled');
        });
      } else {
        // deactivate buttons
        links.forEach((link) => {
          link.classList.add('is-disabled');
        });
      }
    })
  }
});

function showContentPerSearch(searchValue, contentMapping) {
  const foundItems = contentMapping.filter(item => item.text.toLowerCase().includes(searchValue.toLowerCase()));

  // Reset
  document.querySelector('.no-results-container').classList.add('d-none');

  const allItems = document.querySelectorAll('.accordion-fournisseur-section .pa__item');
  if (!searchValue) {
    // Show all
    allItems.forEach(item => {
      item.classList.remove('d-none');
    });
  } else {
    // hide all
    allItems.forEach(item => {
      item.classList.add('d-none');
    });

    // show wanted only
    if (foundItems.length === 0) {
      document.querySelector('.no-results-container').classList.remove('d-none');
    } else {
      foundItems.forEach(item => {
        const parent = document.querySelector('.accordion-fournisseur-section > .pa__item:nth-child(' + item.parent + ')');
        parent.classList.remove('d-none');
        document.querySelector('.accordion-fournisseur-section > .pa__item:nth-child(' + item.parent + ') .pa__item:nth-child(' + item.id + ')').classList.remove('d-none');

        const closedParentBtn = document.querySelector('.accordion-fournisseur-section > .pa__item:nth-child(' + item.parent + ') > .pa__header > .pa__button.collapsed');
        if (closedParentBtn) {
          closedParentBtn.click();
        }
      });
    }
  }
}
